import { QueryWrapper } from '@diamond/shared/data-access';
import { OrderFilter } from '@diamond/shared/types';
import { useMemo } from 'react';
import shallow from 'zustand/shallow';

import { useAuthStore, useShipToStore } from '../stores';

export function useDivisionData() {
  const session = useAuthStore();

  const [selectedShipToDc] = useShipToStore(
    (s) => [s.selectedShipToDc],
    shallow
  );

  const query = QueryWrapper('/order/filters', session.access_token);
  const { data } = query.useQueryGet<OrderFilter>('All Filter Product', {
    distribution_channel: selectedShipToDc,
  });

  const divisionData = useMemo(() => {
    const productData = data as OrderFilter;
    return productData.divisions?.map((val) => {
      return {
        label: val.name,
        value: val.divisi_code,
      };
    });
  }, [data]);

  return {
    divisionData,
  };
}
